import React, { useContext, useRef, useState } from 'react';
import { navigate, useLocation } from '@reach/router';

import { makeStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import EmojiPeopleIcon from '@material-ui/icons/EmojiPeople';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import AuthContext from '../../services/firebase/AuthContext';
import Copyright from '../Copyright';
import { LocationSearching } from '@material-ui/icons';
import LoggingContext from '../../services/logging/LoggingContext';

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

const SignIn = () => {
    const location = useLocation();
    const classes = useStyles();
    const { login } = useContext(AuthContext);
    const errata = useContext(LoggingContext);

    const emailRef = useRef();
    const pwdRef = useRef();
    const [error, setError] = useState();
    const [submittable, setSubmittable] = useState(false);
    const [resetPasswordUrl, setResetPasswordUrl] = useState('/auth/reset');

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await login({ email: emailRef.current.value, password: pwdRef.current.value });

            if (!LocationSearching.pathname || ['signup', 'signin'].includes(location.pathname)) {
                navigate("/");
            }
            else {
                navigate(location.pathname);
            }
        }
        catch (error) {
            errata.log({component: 'SignIn.handleSubmit', user: {
                uid: emailRef.current.value,
                name: 'anonymous'
            }, error});
            setError(error);
        }
    }

    const handleEmailChange = () => {
        setResetPasswordUrl(`/auth/reset/${encodeURI(emailRef.current?.value || '')}`);
        setSubmittable(emailRef.current?.value && pwdRef.current?.value);
    }

    const handlePwdChange = () => {
        setSubmittable(emailRef.current?.value && pwdRef.current?.value);
    }

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>
                <Typography component="h1" variant="h6">The Intermediary Cooperative</Typography>
                <Avatar className={classes.avatar}>
                    <EmojiPeopleIcon />
                </Avatar>
                <Typography component="h1" variant="h5">Sign In</Typography>
                <form className={classes.form} noValidate onSubmit={handleSubmit}>
                    <TextField
                        inputRef={emailRef}
                        onChange={handleEmailChange}
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Email Address"
                        name="email"
                        autoComplete="email"
                        autoFocus
                    />
                    <TextField
                        inputRef={pwdRef}
                        onChange={handlePwdChange}
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                    />
                    {/* <FormControlLabel
                        control={<Checkbox value="remember" color="primary" />}
                        label="Remember me"
                    /> */}
                    {
                        error && <Alert variant="filled" severity="error" onClose={() => setError(undefined)} style={{ marginTop: '0.5rem', marginBottom: '0.5rem' }}><AlertTitle>Sign in Problem</AlertTitle>{error.message}</Alert>
                    }
                    {
                        !error && <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                        disabled={!submittable}
                    >Sign In
                    </Button>
}
                    <Grid container>
                        <Grid item xs>
                            <Link href={resetPasswordUrl} variant="body2">Forgot password?</Link>
                        </Grid>
                        <Grid item>
                            <Link href="/signup/member" variant="body2">
                                {"Don't have an account? Sign Up"}
                            </Link>
                        </Grid>
                    </Grid>
                </form>
            </div>
            <Box mt={8}>
                <Copyright />
            </Box>
        </Container>
    );
}

export default SignIn;